var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "92px",
    height: "92px",
    viewBox: "0 0 92 92",
    enableBackground: "new 0 0 92 92",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2053_",
    d: "M86.8,0.1c-1.9-0.4-3.8,0.6-4.5,2.4C81.2,5,70.6,16,61.5,16.4c-5.2,0.2-10-3.4-15.1-7.2 C39.8,4.4,32.5-1,23.1,0.8C9.2,3.4,2.7,15.9,2.4,16.5c-0.4,0.8-0.5,1.8-0.3,2.7l4,17.9c0,0,0,0,0,0l11.7,51.9 c0.4,1.9,2.1,3.1,3.9,3.1c0.3,0,0.6,0,0.9-0.1c2.2-0.5,3.5-2.6,3-4.8l-6.8-30.3c1.8-2.8,6.9-9.7,14.9-11.5c4.8-1.1,8.6,0.2,13,1.6 c4.9,1.6,10.5,3.5,17.7,1.9C79.5,45.4,89.7,27.4,90,4C90,2.1,88.7,0.5,86.8,0.1z M62.6,41.1c-5,1.1-8.9-0.2-13.4-1.7 c-4.9-1.6-10.4-3.5-17.3-1.9c-6.8,1.5-11.9,5.5-15.4,9.3L16.1,45l-5.9-26c1.7-2.6,6.4-8.8,14.3-10.3c6-1.1,11.1,2.6,17,7 c5.7,4.2,12.3,9,20.2,8.7c6.7-0.3,13.6-4.2,19-8.6C78.4,27.8,72.5,38.8,62.6,41.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.1c77c56a8308a3016ba022178e0cf042.svg";
export { ForwardRef as ReactComponent };